export default {
  syncSetting: {
    // Navigation tabs
    navTabs: {
      all: 'All',
      basicData: 'Basic Data',
      customer: 'Customer Center',
      contractSync: 'Contract Sync',
      system: 'System Settings',
      freight: 'Super Freight',
      order: 'Order Center',
      ehr: 'EHR Integration',
      docControl: 'Document Control'
    },

    // Sync cards
    syncCards: {
      seaport: {
        title: 'Sync Sea Port',
        description: 'Sync sea port basic data information'
      },
      airport: {
        title: 'Sync Air Port',
        description: 'Sync air port basic data information'
      },
      route: {
        title: 'Sync Route',
        description: 'Sync route basic data information'
      },
      chargeItem: {
        title: 'Sync Charge Item',
        description: 'Sync charge item basic data information'
      },
      inquiry: {
        title: 'Sync Inquiry',
        description: 'Sync customer inquiry documents and quotation requests'
      },
      quotation: {
        title: 'Sync Quotation',
        description: 'Sync quotation documents and price information'
      },
      price: {
        title: 'Sync Freight',
        description: 'Sync freight data and fee standard information'
      },
      order: {
        title: 'Sync Order',
        description: 'Sync order information and logistics tracking data'
      },
      task: {
        title: 'Sync Task',
        description: 'Sync task processing information'
      },
      workflow: {
        title: 'Sync Workflow',
        description: 'Sync workflow node configuration'
      },
      surcharge: {
        title: 'Sync Surcharge',
        description: 'Sync freight surcharge information'
      },
      user: {
        title: 'Sync Employee List',
        description: 'Sync enterprise employee information and organizational data'
      },
      client: {
        title: 'Sync Partners',
        description: 'Sync partner information, including suppliers, customers and other basic data'
      },
      supplierEvaluation: {
        title: 'Sync Supplier Evaluation',
        description: 'Sync supplier evaluation data and rating information'
      }
    },

    // Buttons and actions
    actions: {
      editConfig: 'Edit Config',
      cancel: 'Cancel',
      confirm: 'Confirm'
    },

    // Modal
    modal: {
      editConfig: 'Edit Configuration',
      syncPlatform: 'Sync Platform',
      syncMode: 'Sync Mode',
      selectPlatform: 'Please select sync platform',
      selectMode: 'Please select sync mode',
      fileSyncEnabled: 'Enable X→CW file sync',
      fileSyncDocumentType: 'Target file type',
      fileSyncDocumentTypePlaceholder: 'Empty = blank file type'
    },

    // Messages
    messages: {
      configSaved: 'Configuration saved',
      configSaveSuccess: 'Configuration saved successfully',
      configSaveFailed: 'Failed to save configuration',
      configNotFound: 'Configuration item not found',
      loadConfigFailed: 'Failed to load configuration'
    },

    // Log messages
    logs: {
      startInitConfig: 'Start initializing configuration details',
      cannotGetTenantId: 'Cannot get current tenant ID, skip initialization',
      configDefsCount: 'Configuration definitions list',
      configDetailsCount: 'Configuration details list',
      needCreateConfigs: 'Need to create',
      configsToCreate: 'Configurations to create',
      configCreated: 'Configuration created',
      configCreateFailed: 'Failed to create configuration',
      configInitComplete: 'Configuration initialization complete',
      noInitNeeded: 'No initialization needed',
      initConfigFailed: 'Failed to initialize configuration',
      loadAllConfigs: 'Load all configurations',
      syncSwitchStatus: 'Sync switch status',
      syncDetailConfig: 'Sync detailed configuration',
      saveConfig: 'Save configuration',
      switchChangeHandle: 'Switch change handling',
      switchConfigUpdated: 'Switch configuration updated',
      detailConfigUpdated: 'Detailed configuration updated',
      detailConfigName: 'Detailed configuration name'
    }
  },

  ehr: {
    syncTimes: 'Sync Schedule',
    syncTimesPlaceholder: 'Org/position 08:00,18:00; employee every 3h',
    dingtalkTitle: 'DingTalk Configuration',
    dingtalkNotification: 'Enable Work Notification',
    appKey: 'AppKey',
    appSecret: 'AppSecret',
    agentId: 'AgentId',
    testConnection: 'Test Connection',
    testSuccess: 'DingTalk connection successful',
    syncDingtalkUserId: 'Sync DingTalk User IDs',
    syncDingtalkUserIdSuccess: 'Done: success {success}, skip {skip}, fail {fail}',
    configSaved: 'Configuration saved',
    cards: {
      organization: {
        title: 'Organization Sync',
        description: 'Sync branch/office data from IAM'
      },
      department: {
        title: 'Department Sync',
        description: 'Sync department tree from IAM'
      },
      position: {
        title: 'Position Sync',
        description: 'Sync position master data from IAM'
      },
      employee: {
        title: 'Employee Sync',
        description: 'Sync employee accounts from IAM'
      }
    },
    positionPage: {
      keyword: 'Keyword',
      keywordPlaceholder: 'Code or name',
      search: 'Search',
      code: 'Code',
      name: 'Name',
      department: 'Department',
      family: 'Family',
      level: 'Level',
      status: 'Status'
    }
  },

  docControl: {
    cardTitle: 'Document Control Sync',
    cardDescription: 'Sync certificate/report metadata from TMS document control platform',
    syncTimes: 'Sync schedule',
    syncTimesPlaceholder: '00:00,12:00,18:00',
    configSaved: 'Document control sync settings saved',
    statusPartial: 'Partial success'
  },

  supplierContract: {
    cardTitle: 'Supplier Contract Sync',
    cardDescription: 'Synchronize supplier contract headers, details, and files from the Shokz OC contract system',
    syncTimes: 'Sync Times',
    status: 'Sync Status',
    lastSyncAt: 'Last Sync',
    totalCount: 'Total {count}',
    successCount: 'Success {count}',
    failureCount: 'Failed {count}',
    syncNow: 'Sync Now',
    initialStartDate: 'Initial Sync Date',
    initialStartDatePlaceholder: 'Select the initial sync date',
    connectionStatus: 'OC Connection',
    connectionConfigured: 'Configured',
    connectionNotConfigured: 'Not Configured',
    connectionNotice: 'The OC URL and credentials are managed in Nacos. Ask the backend team to configure the connection first.',
    syncTimesPlaceholder: 'For example: 08:00,18:00',
    syncTimesInvalid: 'Use HH:mm format and separate multiple times with commas',
    syncTimesRequired: 'Set at least one sync time before enabling scheduled sync',
    configSaved: 'Supplier contract sync configuration saved',
    saveFailed: 'Failed to save supplier contract sync configuration',
    loadFailed: 'Failed to load supplier contract sync configuration',
    syncSubmitted: 'Supplier contract sync task submitted',
    syncFailed: 'Supplier contract sync failed',
    logTitle: 'Supplier Contract Sync Logs',
    allStatuses: 'All Statuses',
    batchId: 'Batch ID',
    triggerType: 'Trigger Type',
    triggerManual: 'Manual',
    triggerScheduled: 'Scheduled',
    windowStart: 'Window Start',
    windowEnd: 'Window End',
    total: 'Total',
    success: 'Success',
    failure: 'Failed',
    startedAt: 'Started At',
    finishedAt: 'Finished At',
    duration: 'Duration',
    durationValue: '{value} ms',
    errorCode: 'Error Code',
    errorMessage: 'Error Message',
    diagnosticDetails: 'Diagnostic Details',
    pageNumber: 'Page',
    pageSize: 'Page Size',
    latestCondition: 'Latest',
    statusCondition: 'Statuses',
    departmentCondition: 'Department',
    ocReturned: 'OC Total',
    pageReturned: 'Page Returned',
    localAccepted: 'Local Accepted',
    actuallySaved: 'Actually Saved',
    noDiagnosticDetails: 'No diagnostic details',
    logLoadFailed: 'Failed to load supplier contract sync logs'
  },

  syncBar: {
    lastSync: 'Last sync',
    recordCount: '{count} records',
    syncNow: 'Sync Now',
    viewLogs: 'View Logs',
    statusSyncing: 'Syncing',
    statusSuccess: 'Synced',
    statusPartial: 'Partial success',
    statusFailed: 'Sync Failed',
    statusPending: 'Pending',
    triggerSuccess: 'Sync triggered',
    logTitle: 'Sync Logs',
    batchId: 'Batch ID',
    status: 'Status',
    records: 'Records',
    time: 'Time'
  }
}
